import { gqlClient } from './client'
import { REBTEL_CREDITS_BRAND_ID } from '@/utils/constants'

/**
 * Returns the user's Rebtel Credits saved method ({ description }) or null.
 * Only the graph knows about credits; the rest of the saved methods screen
 * keeps using the legacy REST endpoints. Credits are display-only there
 * (no edit/delete/set-primary), so nothing else is read from the graph.
 */
const fetchRebtelCreditsSavedMethod = async () => {
  try {
    let response = await gqlClient.post('/graphql', {
      query: `
      query SavedMethodSearch($where: SavedMethodSearchFilterInput) {
        payments {
          savedMethodSearch(where: $where) {
            items {
              description
              brand {
                id
              }
            }
          }
        }
      }`,
      variables: {
        where: {
          statuses: {
            in: ['ACTIVE']
          }
        }
      },
      operationName: 'SavedMethodSearch'
    })
    if (response.data.errors && response.data.errors.length) {
      throw new Error(response.data.errors[0].message)
    }
    const items = response.data.data.payments.savedMethodSearch.items
    return items.find((item) => item.brand.id === REBTEL_CREDITS_BRAND_ID) || null
  } catch (error) {
    throw error
  }
}

const fetchRebtelCredits = async () => {
  try {
    let response = await gqlClient.post('/graphql', {
      query: `
      query GetMe {
        me {
            currency
            email
            ledger {
                disposableBalance {
                    amount
                    currency
                    formatted
                }
            }
        }
    }`
    })
    return response.data
  } catch (error) {
    throw error
  }
}

const fetchVat = async () => {
  try {
    let response = await gqlClient.post('/graphql', {
      query: `
      query GetMe {
        me {
          ledger {
            vatPercentages {
              vatPercent
              serviceCategory
              productSubCategory
              productCategory
            }
          }
        }
    }`
    })
    return response.data
  } catch (error) {
    throw error
  }
}

const saveNotificationSettings = async (notificationSettings) => {
  try {
    let response = await gqlClient.post('/graphql', {
      query: `
      mutation UserSettingsNotificationUpdate($input:UserSettingsNotificationUpdateInput! )
      {
        userSettingsNotificationUpdate(input:$input) {
          user{
            notificationSettings{
              promotionEmails
              pushNotifications
              smsNotifications
              systemNotifications
            }
          }
        }
      }
      `,
      variables: {
        input: {
          ...notificationSettings
        }
      }
    })
    return response.data
  } catch (error) {
    throw error
  }
}

const getNotificationSettings = async () => {
  try {
    let response = await gqlClient.post('/graphql', {
      query: `
        query getUserNotificationsSettings {
          me {
            notificationSettings {
              promotionEmails
              pushNotifications
              smsNotifications
              systemNotifications
            }
          }
        }
      `
    })
    return response.data
  } catch (error) {
    throw error
  }
}
export {
  fetchRebtelCredits,
  fetchRebtelCreditsSavedMethod,
  fetchVat,
  saveNotificationSettings,
  getNotificationSettings
}



// WEBPACK FOOTER //
// ./src/api/gql/index.js